<template>
  <section class="emails">
    <h4 class="ml-3">{{ $t("lang.label.master_inbox") }}</h4>
    <main class="">
      <div class="contentCenter all ml-2">
        <div class="row">
          <div :class="classExpand()">
            <section class="" v-show="!expanded">
              <div class="row" v-if="!targetId">
                <div class="col-sx-10 col-md-8">
                  <form class=" mb-4">
                    <div class="input-group">
                      <input
                        class="form-control"
                        type="search"
                        v-bind:placeholder="$t('lang.label.quicksearch')"
                        aria-label="Seafrch"
                        v-model="searchFilter"
                      />
                      <div class="input-group-append ">
                        <button
                          class="btn btn-sm btn-secondary themed-hover "
                          type="button"
                          @click="confirmSearch"
                        >
                          <span class="icon-search"></span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-md-4" v-if="groups.length > 0">
                  <select
                    @change="selectClient()"
                    v-model="client"
                    class="form-control"
                  >
                    <option value="false" selected>
                      {{ $t("lang.button.all") }}
                    </option>
                    <option v-for="team in groups" :value="team.id">
                      {{ team.name }}
                    </option>
                  </select>
                </div>
                <div class="col-sx-12 col-md-12 mb-12 ml-0">
                  <a
                    class="text-primary float-right"
                    href="https://www.notion.so/Conditions-link-email-opportunity-1d1a87b80ce14e82b18a479b56a9e346"
                    target="_blank"
                    >Frecuently asked questions</a
                  >
                  <div class="row">
                    <button
                      v-if="!isDashboard"
                      class="float-left btn-sm btn "
                      :class="actualTab == 91 ? 'btn-primary' : ''"
                      @click="
                        goToPage('/emails');
                        actualTab = 91;
                      "
                      type="submit"
                    >
                      Not linked <i class="icon-unlink"></i>
                    </button>

                    <button
                      class="float-left  btn-sm  btn ml-2 "
                      :class="actualTab == 92 ? 'btn-primary' : ''"
                      @click="
                        goToPage('/emailscat/amazonses', 'all');
                        actualTab = 92;
                      "
                      type="submit"
                    >
                      Linked <i class="icon-link"></i>
                    </button>

                    <button
                      v-if="!isDashboard"
                      class="float-left  btn-sm  btn ml-2 "
                      :class="actualTab == 93 ? 'btn-danger' : ''"
                      @click="
                        goToPage('/emailscat/amazonses', '5');
                        actualTab = 93;
                      "
                      type="submit"
                    >
                      Deleted <i class="icon-trash"></i>
                    </button>
                  </div>

                  <div class="row mt-2 ml-1">
                    <button
                      v-for="(st, i) in emailresponsestatus"
                      class="btn-sm float-left btn mr-2 "
                      :class="
                        actualTab == i ? 'btn-primary' : 'btn-' + st.color
                      "
                      @click="
                        goToPage('/emailscat/amazonses', st.id);
                        actualTab = i;
                      "
                      type="submit"
                    >
                      {{ st.description }}
                    </button>
                  </div>

                  <button
                    class="float-left btn-sm btn ml-2 mt-2 btn-outline-secondary "
                    @click="selectAll()"
                    type="submit"
                    v-if="
                      !this.loading && mailsIds.length == 0 && actualTab == 0
                    "
                  >
                    Select All
                  </button>

                  <button
                    v-if="mailsIds.length > 0 && actualTab == 0"
                    class="float-left btn ml-2 btn-outline-secondary "
                    @click="mailsIds = []"
                    type="submit"
                  >
                    Unselect
                  </button>
                  <button
                    v-if="
                      mailsIds.length > 0 && !this.loading && actualTab == 0
                    "
                    class="float-left btn ml-2 btn-success "
                    @click="linkAll()"
                    type="submit"
                  >
                    Attach Opportunity <i class="icon-link"></i>
                  </button>
                  <button
                    v-if="
                      mailsIds.length > 0 && !this.loading && actualTab == 0
                    "
                    class="float-left btn ml-2 btn-danger "
                    @click="deleteAll()"
                    type="submit"
                  >
                    Delete <i class="icon-trash"></i>
                  </button>
                  <FilterSystem
                    class="float-right mr-2"
                    :columns="filterColumns"
                    :reset="resetFilterSystem"
                    :sort="sort"
                    :dir="dir"
                    :filterSystem="filtersDash"
                    :filterOldQuery="oldQuery"
                    :key="filterkey"
                    @callApi="filterNow($event)"
                  />
                  <button
                    class="float-right btn "
                    @click="refresh()"
                    type="submit"
                  >
                    <i class="icon-refresh"></i>
                  </button>

                  <button
                    v-show="expanded"
                    class="mr-2 float-right btn btn-primary themed-button"
                    @click="explodecolumn"
                    type="submit"
                  >
                    <i class="icon-arrow-right"></i>
                  </button>
                </div>
              </div>
            </section>
            <section class="businesses-list">
              <div class=" animated fadeIn fast">
                <div
                  style="
        border: 1px solid rgba(0,0,0,.125);
        border-radius: .25rem;"
                  :class="getStyleOpened()"
                >
                  <div class="table-responsive">
                    <table v-show="!expanded" class="table table-hover">
                      <thead class="thead-dark">
                        <tr>
                          <th v-if="actualTab == 0">
                            <span class="font-weight-bold pl-1">
                              {{ $t("lang.column.selected") }} :
                              {{ mailsIds.length }}</span
                            >
                          </th>
                          <th scope="col">
                            {{ $t("lang.column.client") }}
                          </th>
                          <th scope="col">{{ $t("lang.column.from") }}</th>
                          <th scope="col">{{ $t("lang.column.subject") }}</th>
                          <th scope="col">
                            {{ $t("lang.column.opportunity") }}
                          </th>
                          <th scope="col">{{ $t("lang.column.status") }}</th>
                          <th scope="col">Open Ai Tag</th>
                          <th scope="col">{{ $t("lang.column.date") }}</th>
                          <th scope="col">
                            <div class="btn-group">
                              <a
                                class="dropdown-toggle cursor-pointer"
                                data-toggle="dropdown"
                                data-display="static"
                                aria-haspopup="true"
                                aria-expanded="false"
                                >{{ $t("lang.column.users") }}</a
                              >
                              <div
                                class="dropdown-menu dropdown-menu-right scrolled-div"
                              >
                                <a
                                  class="dropdown-item cursor-pointer"
                                  v-for="(user, index) in salesUsers"
                                  :key="index"
                                  @click="changeSalesUserFilter(user)"
                                >
                                  <span
                                    :class="
                                      isFilteredSalesUser(user)
                                        ? 'icon-check-square-o pr-1'
                                        : 'icon-square-o pr-1'
                                    "
                                  ></span>
                                  {{ user.name + " " + user.lastname }} <br />
                                </a>
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="loading">
                        <tr>
                          <td colspan="7" class="flex justify-center">
                            <LoadingSpinner />
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-if="!loading && emails !== undefined">
                        <tr
                          v-for="(email, key) in emails.list"
                          :key="key"
                          :class="getClassOpened(email.opened, email.id)"
                          class=" itememail"
                        >
                          <td v-if="actualTab == 0">
                            <input
                              type="checkbox"
                              v-model="mailsIds"
                              :value="email.id"
                            />
                            <span
                              @click="deleteEmail(email.id)"
                              class="ml-2 text-white btn-danger btn-sm btn cursor-pointer"
                              ><i class="icon-close"></i>
                            </span>
                          </td>
                          <td>
                            <strong>{{ email.client_name }}</strong>
                            <!-- {{ email.response_from | capitalize }} -->
                          </td>
                          <td>
                            <strong>{{ email.label }}</strong>
                            {{ email.response_from | capitalize }}
                            <button v-if="!targetId" class="btn btn-sm btn-danger" @click="addToNotValid(email.response_from)"><i class="icon-close mr-1"></i>Block email address</button>
                          </td>
                          <td
                            class="cursor-pointer"
                            @click="
                              goToEmail(
                                email.id,
                                email.business_name,
                                email.response_subject
                              )
                            "
                          >
                            <strong>{{ email.response_subject }}</strong>
                          </td>
                          <td>
                            <strong
                              ><a
                                class="text-primary ml-2"
                                target="_blank"
                                :href="'/opportunities/' + email.link_id"
                                >{{ email.business_name }}</a
                              ></strong
                            >
                          </td>
                          <td>
                            Last email:

                            <div
                              v-if="email.status !== 'valid'"
                              class="badge"
                              :class="statusBadge(email.status)"
                            >
                              {{ email.status }}
                            </div>
                            <div
                              v-if="email.tag_manual == '1'"
                              class="badge badge-primary"
                            >
                              TAG MANUAL
                            </div>
                            <div
                              class="badge"
                              :class="statusEmail(email.response_label)"
                            >
                              {{ email.response_label }}
                            </div>
                            <div
                              v-if="email.business_contact_status != ''"
                              class="badge btn-danger"
                            >
                              {{ email.business_contact_status }}
                            </div>
                            <div
                              v-if="
                                email.taglinks != null &&
                                  email.taglinks != undefined
                              "
                            >
                              Opportunity tags:
                              <span
                                v-for="tag in email.taglinks.split(',')"
                                class="badge mr-2"
                                :class="statusBadge(tag)"
                                >{{ tag }}</span
                              >
                            </div>
                          </td>
                          <td>
                              <span
                                
                                class="badge mr-2 badge-warning"
                                
                                >{{ email.ai_tag }}</span
                              >
                            <small >{{ }}</small>
                          </td>
                          <td>
                            <small>{{ email.response_date }}</small>
                          </td>
                          <td>
                            <small>{{
                              email.user_name + " " + email.user_lastname
                            }}</small>
                            <br />
                            <small>{{ email.response_to }}</small>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table v-show="expanded" class="table table-hover">
                      <thead class="thead-dark">
                        <tr>
                          <th>
                            <span class="font-weight-bold pl-1">
                              {{ mailsIds.length }}</span
                            >
                          </th>
                          <th scope="col">{{ $t("lang.column.from") }}</th>
                        </tr>
                      </thead>

                      <tbody v-if="emails !== undefined">
                        <tr
                          v-for="(email, key) in emails.list"
                          :key="key"
                          :class="getClassOpened(email.opened, email.id)"
                          class="itememail"
                        >
                          <td>
                            <input
                              type="checkbox"
                              v-model="mailsIds"
                              @click="select"
                              :value="email.id"
                            />
                            <i class="icon-envelope-o d-block"></i>
                          </td>
                          <td>
                            <div class="d-block">
                              <span
                                class="badge mr-2"
                                :class="statusBadge(email.status)"
                                >{{ email.status }}</span
                              >
                              <span
                                class="badge "
                                :class="statusEmail(email.response_label)"
                                >{{ email.response_label }}</span
                              >
                            </div>
                            <div class="d-block">
                              <div class="d-flex align-items-center">
                                <small
                                  ><span
                                    class="info-mail-collapse"
                                    v-if="email.label"
                                    >{{ email.label }}</span
                                  >
                                  <span class="info-mail-collapse">{{
                                    email.response_from | capitalize
                                  }}</span></small
                                >
                                <small class="ml-2 pb-1"
                                  ><span>{{ email.response_date }}</span></small
                                >
                              </div>
                            </div>
                            <div
                              v-if="
                                email.taglinks != null &&
                                  email.taglinks != undefined
                              "
                            >
                              Opportunity tags:
                              <span
                                v-for="tag in email.taglinks.split(',')"
                                class="badge mr-2"
                                :class="statusBadge(tag)"
                                >{{ tag }}</span
                              >
                            </div>
                            <div
                              class="cursor-pointer"
                              @click="
                                goToEmail(
                                  email.id,
                                  email.business_name,
                                  email.response_subject
                                )
                              "
                            >
                              <strong>{{ email.response_subject }}</strong>
                            </div>
                            <div>
                              <small class="mr-2">{{
                                email.business_name
                              }}</small>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="table-footer row mb-2 mt-2">
                    <div class="col-12 text-left mb-3">
                      <span class="font-weight-bold"
                        >{{ $t("lang.label.showing") }} {{ firstInPage }}
                        {{ $t("lang.label.to") }} {{ lastInPage }}
                        {{ $t("lang.label.of") }} {{ totalEmails }}
                        {{ $t("lang.label.emails") }}.</span
                      >
                    </div>
                    <div class="col-md-9 col-8">
                      <button
                        type="button"
                        class="btn btn-primary themed-button btnNavTabla"
                        :disabled="isFirstPage"
                        @click="
                          currentPage--;
                          mailsIds = [];
                        "
                      >
                        <span class="icon-angle-double-left mr-2" /><span
                          class="btn-name"
                          >{{ $t("lang.button.previous") }}</span
                        >
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary themed-button ml-2 btnNavTabla"
                        :disabled="isLastPage"
                        @click="
                          currentPage++;
                          mailsIds = [];
                        "
                      >
                        <span class="btn-name">{{
                          $t("lang.button.next")
                        }}</span
                        ><span class="icon-angle-double-right ml-2" />
                      </button>
                    </div>
                    <div class="col-3 dropdown text-right">
                      <button
                        type="button"
                        class="btn btn-secondary dropdown-toggle themed-button btnNavTabla"
                        id="dropdownCantPerPage"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        data-offset="10,20"
                      >
                        <span
                          >{{ cantPerPage }}
                          {{ $t("lang.button.perpage") }}</span
                        >
                      </button>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownCantPerPage"
                      >
                        <a
                          class="dropdown-item cursor-pointer"
                          v-for="(optionCant, index) in cantPerPageOptions"
                          :key="index"
                          @click="cantPerPage = optionCant"
                          >{{ optionCant }} {{ $t("lang.button.perpage") }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div
          class="col-md-8 mailDetail"
          v-show="expanded"
          v-if="actualThread || actualEmail"
        >
          <section class="" v-show="expanded">
            <div class="row">
              <div class="col-sx-12 col-md-12 mb-12">
                <button
                  class="float-right btn "
                  @click="refresh()"
                  type="submit"
                >
                  <i class="icon-refresh"></i>
                </button>
                <button
                  v-show="expanded"
                  class="mr-2 float-right btn btn-primary themed-button"
                  @click="explodecolumn"
                  type="submit"
                >
                  <i class="icon-arrow-right"></i>
                </button>

                <EmailsView
                  :key="actualThread"
                  v-if="actualThread"
                  :selectedEmailId="actualThread"
                  :selectedEmailSubject="getSubject(actualEmail)"
                />
                <EmailsView
                  :key="actualEmail"
                  v-if="actualEmail"
                  :selectedEmailId="actualEmail"
                  :selectedEmailSubject="getSubject(actualEmail)"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { router } from "@/_helpers";
import { statusBadgeMixin } from "@/_mixins/";
import {
  emailsService,
  usersService,
  opportunitiesService,
  monitorService,
  adminService
} from "@/_services";
import Header from "@/components/Header.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import EmailsThread from "@/components/Emails/EmailThread.vue";
import EmailsView from "@/components/Emails/EmailView.vue";
import FilterSystem from "@/components/FilterSystem.vue";
export default {
  data() {
    return {
      filterColumns: [
        {
          name: "Date",
          name_: "date",
          type: "date",
          field: "er.response_date"
        },
        {
          name: "Email",
          name_: "email",
          type: "string",
          field: "er.response_from"
        },
        {
          name: "Client",
          name_: "client",
          type: "string",
          field: "cl.name"
        },
        {
          name: "Utilisateurs Email",
          name_: "name",
          type: "string",
          field: "er.response_to"
        },
        {
          name: "Lead EPS",
          name_: "provider_email",
          type: "string",
          field: "bc.provider_email"
        }
      ],
      key: 232332,
      sort: "",
      dir: "",
      oldQuery: "",
      resetFilterSystem: false,
      filterkey: 3444,
      emailresponsestatus: [],
      filtersDash: {},
      client: false,
      groups: [],
      actualTab: 0,
      finish_loading: 0,
      currentPage: 1,
      cantPerPage: 50,
      salesUsers: [],
      cantPerPageOptions: [5, 10, 20, 50, 100],
      searchFilter: "",
      selected: [],
      allSelected: false,
      actualEmail: "",
      actualThread: "",
      expanded: false,
      mailsIds: []
    };
  },

  mixins: [statusBadgeMixin],

  components: {
    LoadingSpinner,
    EmailsThread,
    EmailsView,
    FilterSystem
  },

  watch: {
    currentPage() {
      this.searchEmails();
    },
    cantPerPage() {
      this.searchEmailsWithPageReset();
    },
    searchFilter() {
      this.searchFilter = this.$sanitize(this.searchFilter);
    }
  },
  computed: {
    ...mapState({
      loading: state => state.emails.loading,
      filters: state => state.emails.allFilters,
      emails: state => state.emails.all.data,
      currentUser: state => state.authentication.user
    }),

    user() {
      return this.$store.state.authentication.user;
    },
    isFirstPage() {
      return this.currentPage === 1;
    },

    isLastPage() {
      return this.currentPage === this.pageCount;
    },

    pageCount() {
      var cantPage = this.totalEmails / this.cantPerPage;
      var fixedCantPage = parseInt(cantPage.toFixed());
      if (cantPage > fixedCantPage) {
        return fixedCantPage + 1;
      } else {
        return fixedCantPage;
      }
    },

    firstInPage() {
      return (this.currentPage - 1) * this.cantPerPage + 1;
    },

    lastInPage() {
      if (
        this.totalEmails >= this.firstInPage &&
        this.totalEmails <= this.currentPage * this.cantPerPage
      ) {
        return this.totalEmails;
      } else {
        return this.currentPage * this.cantPerPage;
      }
    },

    totalEmails() {
      if (this.emails !== undefined && this.emails.total !== undefined) {
        return this.emails.total;
      } else {
        return 0;
      }
    }
  },
  props: {
    selectedCatId: String,
    isDashboard: {
      default: false
    },
    targetId: {
      type: String,
      default: null
    }
  },
  created() {
    if (screen.width <= 480) {
      this.cantPerPage = 5;
    }
    this.getEmailResponseStatus();

    this.getClients();

    this.searchFilter = 4;
    this.actualTab = 0;
    if (this.isDashboard) {
      this.searchFilter = "all";
      this.actualTab = 92;
    } else {
      /*this.refresh();*/
      this.resetAllFilters();
      if (filter) {
        this.searchFilter = filter;
      }
    }

    /*this.getEmails();
    this.getAllSalesUsers();*/
    if(this.targetId){
      this.refresh('all')
      this.searchEmails(this.targetId)
    }
  },
  methods: {
    ...mapActions("emails", {
      getAllEmails: "getAll",
      setSalesUserFilter: "setSalesUserFilter",
      setClientFilter: "setClientFilter",
      startLoading: "startLoading",
      finishLoading: "finishLoading"
    }),
    addToNotValid(word){
      
      this.$swal({
        type: "warning",
        text: this.$t("lang.label.areyousure"),
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: "#81c784",
        cancelButtonColor: "#d33a2c",
      }).then((response) =>{
        if(response.value){
          adminService.insertOliverVariables(word,'novalidwords');
          this.$swal({
            type: "success",
            text: this.$t("lang.label.emailSettingSuccessfully"),
            showConfirmButton: false,
            timer: 1500
          })
        }
      })
      
    },
    getEmailResponseStatus() {
      emailsService.getEmailResponseStatus().then(result => {
        this.emailresponsestatus = result;
      });
    },
    selectClient() {
      this.setClientFilter({ clientFilter: this.client }).then(result =>
        this.searchEmailsWithPageReset()
      );
    },
    getClients() {
      monitorService.getClients().then(result => {
        this.groups = result;
      });
    },
    deleteEmail(id) {
      emailsService.setValidStatus(id, 5, "");
      let newlist = [];
      this.emails.list.forEach(email => {
        if (id != email.id) {
          newlist.push(email);
        }
      });
      this.emails.list = newlist;
      this.key++;
    },
    selectAll() {
      this.emails.list.forEach(email => {
        this.mailsIds.push(email.id);
      });
    },
    deleteAll() {
      this.startLoading();

      this.emails.list.forEach(email => {
        this.finish_loading = 0;
        if (this.mailsIds.indexOf(email.id) >= 0) {
          this.startLoading();
          emailsService.setValidStatus(email.id, 5, "").then(res => {
            this.finish_loading++;
            if (this.mailsIds.length == this.finish_loading) {
              this.finishLoading();
              this.refresh();
              this.$emit("refresh");
            }
          });
        }
      });
    },
    linkAll() {
      this.startLoading();

      this.emails.list.forEach(email => {
        this.finish_loading = 0;
        if (this.mailsIds.indexOf(email.id) >= 0) {
          this.startLoading();
          opportunitiesService
            .autoLink(email.response_id, email.response_to, email.id)
            .then(res => {
              this.finish_loading++;
              if (this.mailsIds.length == this.finish_loading) {
                this.finishLoading();
                this.refresh();
                this.$emit("refresh");
              }
            });
        }
      });
    },
    autoLink(response_id, response_to, id) {
      this.startLoading();
      opportunitiesService.autoLink(response_id, response_to, id).then(res => {
        if (res !== null) {
          this.getClients();
          this.getEmail();
        } else {
          this.oppSelected = null;
        }
        this.finishLoading();
      });
    },
    getSubject(email_id) {
      this.emails.list.forEach(email => {
        if (email.id == email_id) {
          return email.response_subject;
        }
      });
    },
    classExpand() {
      if (this.expanded) {
        return "ml-10 expandedlist";
      } else {
        return "col-md-12";
      }
    },
    getStyleOpened() {
      if (this.expanded) {
        return "";
      }
    },
    goToPage(url, filter) {
      this.$router.push(url);
      this.refresh(filter);
    },
    getClassOpened(opened, email_id) {
      if (this.actualEmail == email_id) return "bg-email-active-open";
      if (this.actualThread == email_id) return "bg-email-active-open";

      if (opened) return "bg-white";
      else return "bg-email-active";
    },
    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),
    getEmails() {
      if (this.emails == undefined) {
        this.searchEmails();
      }
    },
    getAllSalesUsers() {
      usersService.getAll().then(users => (this.salesUsers = users));
    },
    isFilteredSalesUser(salesUser) {
      return (
        this.filters.salesUserFilter !== undefined &&
        this.filters.salesUserFilter === salesUser.id
      );
    },
    changeSalesUserFilter(user) {
      var userId = this.isFilteredSalesUser(user) ? "" : user.id;
      this.setSalesUserFilter({ salesUser: userId }).then(result =>
        this.searchEmailsWithPageReset()
      );
    },
    refresh(filter) {
      this.resetAllFilters();
      if (filter) {
        this.searchFilter = filter;
      }
      this.searchEmails(this.targetId);
    },
    explodecolumn() {
      this.expanded = false;
    },
    searchEmails(targetId = null) {
      this.getAllEmails({
        currentPage: this.currentPage,
        cantPerPage: this.cantPerPage,
        searchFilter: this.searchFilter,
        filters: this.filtersDash,
        targetId: (targetId) ? targetId : 0,
      });
    },
    searchEmailsWithPageReset() {
      this.getAllEmails({
        currentPage: this.currentPage,
        cantPerPage: this.cantPerPage,
        searchFilter: this.searchFilter
      }).then(result => (this.currentPage = 1));
    },
    confirmSearch() {
      this.getAllEmails({
        currentPage: this.currentPage,
        cantPerPage: this.cantPerPage,
        searchFilter: this.searchFilter
      }).then(result => (this.currentPage = 1));
    },
    resetAllFilters() {
      this.searchFilter = "";
    },

    showEmail(email_id) {
      return this.actualEmail == email_id;
    },
    showThread(email_id) {
      return this.actualThread == email_id;
    },
    filterNow(filter) {
      this.filtersDash = JSON.parse(JSON.stringify(filter));
      //console.log(this.filtersDash);
      this.searchEmails();
    },
    goToEmail(email_id, email_opportunity, email_subject) {
      if (email_opportunity === null) {
        this.actualEmail = email_id.toString();
        this.actualThread = "";
      } else {
        this.actualThread = email_id.toString();
        this.actualEmail = "";
      }
      this.expanded = true;
      router.push({
        name: "emails",
        params: { id: email_id.toString(), name: email_subject.toString() }
      });
    },
    select: function() {
      this.allSelected = false;
    }
  }
};
</script>
<style>
.itememail:hover {
  background-color: white !important;
}
.info-mail-collapse {
  width: 100px;
  font-weight: 600;
  /* color: #5054EB; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* resize: horizontal; */
}
.em-collapse .table-footer .col-9 {
  max-width: 40% !important;
  padding-right: 0px;
  margin-right: 0px;
}
.em-collapse .table-footer .col-3 {
  padding-left: 0px;
  margin-left: 0px;
}
.em-collapse .table-footer .btn-primary.themed-button,
.em-collapse .table-footer .btn.btn-secondary.dropdown-toggle.themed-button {
  padding: 0.175rem 0.5rem;
}
.em-collapse .table-footer .btn-name {
  display: none;
}

.expandedlist {
  position: fixed !important;
  top: 0px;
  bottom: 0px;
  margin-left: -15px;
  overflow-y: scroll;
  width: 30%;
}

.itememail:hover {
  background-color: #d6d6d6 !important;
}
.bg-email-active {
  background-color: #dfe0fc !important;
}
.bg-email-active-open {
  background-color: #dedede !important;
}
</style>
